import httpService from '@/services/core/http.service';

class SessionService {
    route = 'administrators';

    grid = () => httpService.getDxDataSource(`${this.route}/grid`);
    getById = userId => httpService.get(`${this.route}/${userId}`);
    delete = userId => httpService.delete(`${this.route}/${userId}`);
    create = user => httpService.post(`${this.route}`, user);
    save = (userId, user) => httpService.put(`${this.route}/${userId}`, user);
}

export default new SessionService();
